<template>
	<div class="about">
		<img src="@/assets/images/gg.png" style="width: 100%;position: absolute;top: 50%;left: 0%;">
		<ul style="margin-top: 104px">
			<li v-for="(item,index) in noticess" :key="index" class="lli1">


			<router-link :to="{ path:'/gonggaoDetails',query:{ id:item.id }}" class="list">
					
				 		<div class="img" :style="{'backgroundImage':'url('+item.img+')'}">
				 		
						</div>
				 		<!-- <div class="container">
							<h2>{{ item.title }}</h2>
				 		</div> -->
				 	
				 		
						<div class="Hi">
							<h2 class="title1">{{ item.title }}</h2>
				 			<h2 class="sj">时间:&nbsp&nbsp&nbsp&nbsp<u>{{ item.created_at }}</u></h2>
				 		</div>
				 		<div class="zhai1">
				 			{{item.content}}
				 		</div>
				 		
				 
				 
			</router-link>	


			</li>
		</ul>
		<ul class="uul">
			<li class="lli2" v-for="(item,index) in noticesss" :key="index" style="position: relative;">


			<router-link :to="{ path:'/gonggaoDetails',query:{ id:item.id }}" class="list">
				
				 	<div class="img2" :style="{'backgroundImage':'url('+item.img+')'}">
				 		
					</div>
				 		
				 		
						<div class="Hi2">
				 			<h2 style="color: #ccc;margin: 20px">时间:&nbsp&nbsp&nbsp&nbsp<u>{{ item.created_at }}</u></h2>
				 		</div>
				 
				 <div class="container1">
				 	
				 	
				 	
					<h2>{{ item.title }}</h2>
					
					
					

				 </div>
				 <div class="zhai">
				 			{{item.content}}
				 </div>
			</router-link>	


			</li>
		</ul>
		<button v-on:click="click()" v-if="limit==3">查看更多>></button>
	</div>
</template>
<script>
export default {
	metaInfo: {
		title: "拍界——唤醒您的沉睡资产",
		meta: [{
			name: "keywords",
			content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}, {
			name: "description",
			content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}]
	},
	data (){
	return{
			notices: [],
			noticess:[],
			noticesss:[],
			limit:3,
			page:1,
			
		}
	 },
	methods:{
           click:function(){
           	
this.page++
              this.axios.get('https://api.paijie.com/notices', {
      params: {
        limit:this.limit,
        page:this.page
      }
    })
		.then((response) => {
			if(response.data.error.code == 0){
				this.notices = this.noticesss.concat(response.data.notices);
			
				this.noticesss  = this.notices.slice(0)
				
			}
			console.log(this.noticesss+"aaaaaa");
		})
              
             }
           },
	created(){
		// 显示公共栏
		this.$emit('header', true)
		this.$emit('footer', true)
		// 请求页面数据
		this.axios.get('https://api.paijie.com/notices', {
      params: {
        limit:this.limit,
        page:this.page
      }
    })
		.then((response) => {
			if(response.data.error.code == 0){
				this.notices = response.data.notices;
				
				this.noticess  = this.notices.slice(0,3)
				this.noticesss  = this.notices.slice(3)
				
			}
			console.log(this.content+"aaaaaa");
		})
		.catch(() => {
				// console.log(response.data.error.message)
		})
		// 页面至顶部
		window.scrollTo(0,0);
		this.page++
              this.axios.get('https://api.paijie.com/notices', {
      params: {
        limit:this.limit,
        page:this.page
      }
    })
		.then((response) => {
			if(response.data.error.code == 0){
				this.notices = this.noticesss.concat(response.data.notices);
			
				this.noticesss  = this.notices.slice(0)
				
			}
			console.log(this.noticesss+"aaaaaa");
		})
	},
	
	
	
	computed: {
			
	}
}
</script>